import * as moment from 'moment';

import { BIRTH_DATE_FORMAT } from 'constants/account';
import { AccountProfileForm } from 'models/account';
import { ErrorValidation } from 'models/error';

export function validate(formValue: AccountProfileForm) {
  const errors: ErrorValidation = {};

  if (!formValue.name) {
    errors.name = 'form.error.required';
  }

  if (!formValue.nationalCardNumber) {
    errors.nationalCardNumber = 'form.error.required';
  }

  if (!formValue.birthPlace) {
    errors.birthPlace = 'form.error.required';
  }

  if (!formValue.birthDate) {
    errors.birthDate = 'form.error.required';
  } else if (!moment.utc(formValue.birthDate, BIRTH_DATE_FORMAT).isValid()) {
    errors.birthDate = 'form.error.invalid.birthDate.format';
  }

  if (!formValue.address) {
    errors.address = 'form.error.required';
  }

  if (!formValue.motherName) {
    errors.motherName = 'form.error.required';
  }

  return errors;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/validation/account/accountProfileForm.ts